const AboutSection = () => {
  return (
    <div className="flex items-center justify-center bg-oldGreen bg-gradient-to-b from-oldGreen to-green-700 text-white px-4 py-20 text-center">
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold">About Us</h1>
    </div>
  );
};

export default AboutSection;
